// @ts-strict-ignore
import { useTranslation } from "react-i18next";

import { Spacer } from "@aviary";
import { useSearchParams } from "@shared/react-router-dom/react-router-dom";
import type { PatientAttributes } from "@unauthenticated/shared/data/types/PatientAttributes.d";
import { SignUpHeader } from "@unauthenticated/signupSignin/components/SignUpHeader/SignUpHeader";
import { SignUpTitle } from "@unauthenticated/signupSignin/components/SignUpTitle/SignUpTitle";
import { StoreLandingLayout } from "@unauthenticated/signupSignin/components/StoreLandingLayout/StoreLandingLayout";
import { StoreLogo } from "@unauthenticated/signupSignin/components/StoreLogo/StoreLogo";
import { StoreOffersPill } from "@unauthenticated/signupSignin/components/StoreOffersPill/StoreOffersPill";
import { l } from "@unauthenticated/signupSignin/locales/i18n";
import { EmailCheckForm } from "@unauthenticated/signupSignin/scenes/PatientAuthStartPage/EmailCheckForm/EmailCheckForm";

interface Props {
  patientAttributes: PatientAttributes;
  additionalAttributes?: any;
  ssoErrors?: string;
  storeId?: string;
  isPreview?: boolean;
  isStoreOwner: boolean;
  activePatientPromotion?: boolean;
  isStorefronts?: boolean;
}

const PatientAuthStartPage = ({
  patientAttributes,
  additionalAttributes,
  ssoErrors,
  storeId,
  isPreview = false,
  isStoreOwner,
  activePatientPromotion,
  isStorefronts,
}: Props) => {
  const { t } = useTranslation();
  const { storeLogo, organizationLogo, storeName, pracAvatar, isStoreIntake } = patientAttributes;
  const [searchParameters] = useSearchParams();
  const isIntake = searchParameters.get("intake") === "true";
  const showStoreOffersPill = !isStoreIntake || (isStoreIntake && !isIntake);

  const signUpTitle = isStorefronts ? t(l.common.enterYourEmail) : storeName;

  return (
    <StoreLandingLayout
      storeName={storeName}
      storeId={storeId}
      pracAvatar={pracAvatar}
      isPreview={isPreview}
      isStoreOwner={isStoreOwner}
      isActivePromotion={activePatientPromotion}
      isStorefronts={isStorefronts}
      organizationLogo={organizationLogo}
    >
      <SignUpHeader isStorefronts={isStorefronts}>
        {!isStorefronts && <StoreLogo storeLogo={storeLogo} storeName={storeName} />}
        <SignUpTitle title={signUpTitle} />
        {!isStorefronts && !!showStoreOffersPill && (
          <StoreOffersPill patientAttributes={patientAttributes} />
        )}
      </SignUpHeader>
      <Spacer height={isStorefronts ? "one" : "double"} />
      <EmailCheckForm
        patientAttributes={patientAttributes}
        additionalAttributes={additionalAttributes}
        ssoErrors={ssoErrors}
        storeId={storeId}
        isPreview={isPreview}
        isStorefronts={isStorefronts}
      />
    </StoreLandingLayout>
  );
};

export { PatientAuthStartPage };
